export const GET_ALL_DEVIS_REQUEST = "GET_ALL_DEVIS_REQUEST";
export const GET_ALL_DEVIS_SUCCESS = "GET_ALL_DEVIS_SUCCESS";
export const GET_ALL_DEVIS_FAIL = "GET_ALL_DEVIS_FAIL";

export const GET_DEVIS_REQUEST = "GET_BONCOMMANDE_REQUEST";
export const GET_BONCOMMANDE_SUCCESS = "GET_BONCOMMANDE_SUCCESS";
export const GET_BONCOMMANDE_FAIL = "GET_BONCOMMANDE_FAIL";

export const ADD_DEVIS_REQUEST = "ADD_DEVIS_REQUEST";
export const ADD_DEVIS_SUCCESS = "ADD_DEVIS_SUCCESS";
export const ADD_DEVIS_FAIL = "ADD_DEVIS_FAIL";

export const UPDATE_DEVIS_REQUEST = "UPDATE_DEVIS_REQUEST";
export const UPDATE_DEVIS_SUCCESS = "UPDATE_DEVIS_SUCCESS";
export const UPDATE_DEVIS_FAIL = "UPDATE_DEVIS_FAIL";

export const DELETE_DEVIS_REQUEST = "DELETE_DEVIS_REQUEST";
export const DELETE_DEVIS_SUCCESS = "DELETE_DEVIS_SUCCESS";
export const DELETE_DEVIS_FAIL = "DELETE_DEVIS_FAIL";

export const ADD_DVARTICLE_REQUEST = "ADD_DVARTICLE_REQUEST";
export const ADD_DVARTICLE_SUCCESS = "ADD_DVARTICLE_SUCCESS";
export const ADD_DVARTICLE_FAIL = "ADD_DVARTICLE_FAIL";

export const UPDATE_DVARTICLE_REQUEST = "UPDATE_DVARTICLE_REQUEST";
export const UPDATE_DVARTICLE_SUCCESS = "UPDATE_DVARTICLE_SUCCESS";
export const UPDATE_DVARTICLE_FAIL = "UPDATE_DVARTICLE_FAIL";

export const DELETE_DVARTICLE_REQUEST = "DELETE_DVARTICLE_REQUEST";
export const DELETE_DVARTICLE_SUCCESS = "DELETE_DVARTICLE_SUCCESS";
export const DELETE_DVARTICLE_FAIL = "DELETE_DVARTICLE_FAIL";
